export default class UserActivationController {

    constructor($state, $stateParams, $ionicLoading, ApiAuthentication) {

        this.token = $stateParams.token;
        this.$ionicLoading = $ionicLoading;
        this.ApiAuthentication = ApiAuthentication;
        this.loading = [];
        this.activationSuccess = false;
    }

    init() {
    	this.showLoading();
    	this.ApiAuthentication.activateUser(this.token).then((response) => {
            if(undefined !== response){
                this.activationSuccess = true;
            }  			
    		this.hideLoading();
    	})
    }

    showLoading(){
		this.loading.push(1);
		this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });
	}

	hideLoading(){
		this.loading.pop();
		if(this.loading.length === 0){
			this.$ionicLoading.hide();
		}
	}

}



/** WEBPACK FOOTER **
 ** ./src/app/components/extras/userActivation.controller.js
 **/